import { useQuery } from '@apollo/client/react'
import { Alert, Table } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import {
  FetchTenantDocument,
  type FetchTenantQuery,
} from '~app/graph/generated/graphql'

type CustomerInfoRow = FetchTenantQuery['fetchTenant'][number]

const TableWrapper = styled.div`
  width: 100%;
`

interface Props {
  customerPublicId: string | null
}
type InnerProps = Props

const CustomerInfoTable = ({ customerPublicId }: InnerProps) => {
  const { t } = useTranslation()
  const { data, error, loading } = useQuery(FetchTenantDocument, {
    skip: !customerPublicId,
    variables: { publicId: customerPublicId },
  })

  const rows: CustomerInfoRow[] = data?.fetchTenant ?? []

  if (error) {
    return (
      <TableWrapper>
        <Alert
          message={t('documentView.customerInfoError')}
          showIcon
          type="error"
        />
      </TableWrapper>
    )
  }

  return (
    <TableWrapper>
      <Table<CustomerInfoRow>
        locale={{ emptyText: t('documentView.PublicIdNone') }}
        columns={[
          {
            title: t('misc.contactName'),
            dataIndex: 'contactName',
            key: 'contactName',
          },
          {
            title: t('misc.companyName'),
            dataIndex: 'businessName',
            key: 'businessName',
          },
          {
            title: t('misc.firstName'),
            dataIndex: 'firstName',
            key: 'firstName',
          },
          {
            title: t('misc.lastName'),
            dataIndex: 'lastName',
            key: 'lastName',
          },
          {
            title: t('content.addressForm.street'),
            dataIndex: 'streetAddress',
            key: 'streetAddress',
          },
          {
            title: t('content.addressForm.zip'),
            dataIndex: 'zipCode',
            key: 'zipCode',
          },
          {
            title: t('content.addressForm.city'),
            dataIndex: 'city',
            key: 'city',
          },
        ]}
        dataSource={rows}
        loading={loading}
        pagination={false}
        scroll={{ y: 320 }}
        size="small"
        indentSize={0}
      />
    </TableWrapper>
  )
}

export default CustomerInfoTable
